/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WizardService} from '../../../shared/wizard/wizard.service';
import {UntypedFormBuilder} from '@angular/forms';
import {NgbDatepickerConfig, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {CustomDatepickerI18n, I18n} from '../../../shared/calendar/calendar-strings.service';
import {WizardStepComponent} from '../../../shared/wizard/wizard-step.component';
import {StepHeaderModel} from './step-header.model';
import {WizardIconEnum} from '../../../shared/wizard/wizard-icon.enum';
import {SpoHeaderDataModel} from '../../models/spo-header-data.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-step-header',
    templateUrl: './step-header.component.html',
    styleUrls: ['./step-header.component.css'],
    providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }, NgbDatepickerConfig],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepHeaderComponent extends WizardStepComponent implements OnInit {

    @Input() stepIndex: number;
    stepModel = {
        canSave: false,
        canSend: false,
        icon: WizardIconEnum.NONE,
    } as StepHeaderModel;

    public loading = false;
    subscriptions = new Subscription();

    constructor(
            private formBuilder: UntypedFormBuilder,
            wizardService: WizardService) {

        super(wizardService);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    formUpdate = (formValues: SpoHeaderDataModel): void => {
        this.updateStepModel(formValues);
        this.sendUpdateForm();
    };

    manageLoadingForm = (formIsLoading: boolean): void => {
        this.loading = formIsLoading;
    };

    isStepTouched = (formTouched: boolean): void => {
        this.stepModel.isTouched = formTouched;
    };

    updateStepModel = (formValues: SpoHeaderDataModel): void => {
        this.stepModel.data = formValues;
        this.stepModel.canSave = this.canSave(formValues);
        this.stepModel.canSend = this.canSend(formValues);

        if (this.stepModel.canSend) {
            this.stepModel.icon = WizardIconEnum.SUCCESS;
        } else {
            this.stepModel.icon = WizardIconEnum.ERROR;
        }
    };

    private canSave = (formValues: SpoHeaderDataModel): boolean => formValues.partner?.code != null
            && formValues.shipToParty?.code != null
            && formValues.supplyingPackingPlant?.code != null;

    private canSend = (formValues: SpoHeaderDataModel): boolean => this.canSave(formValues)
            && formValues.requestedDate != null
            && formValues.transportMode?.code != null
            && this.transportServiceIsValid(formValues)
            && this.justificationIsValid(formValues)
            && formValues.reason?.code != null;

    private transportServiceIsValid = (formValues: SpoHeaderDataModel): boolean => formValues.requiresTransportService ?
            formValues.transportService?.code != null : true;


    private justificationIsValid = (formValues: SpoHeaderDataModel): boolean =>
            formValues.transportService?.requiresJustification ? formValues.justification?.length > 0 : true;
}
